jQuery(document).ajaxComplete(function () {
  addWcCheck();
});

function addWcCheck() {
  let element_checkbox = jQuery('.woocommerce [type="checkbox"]');
  let element_radio = jQuery('.woocommerce [type="radio"]');

  element_radio.after('<span class="js-wc-check">');
  element_checkbox.after('<span class="js-wc-check">');

  jQuery('.js-wc-check').click(function () {
    jQuery(this).prev('input').click();
  });
}
